import { defineCopy } from '@floorfile/i18n'
import { attachmentsCopy } from './copy'

export const attachmentsOfflineCopy = defineCopy('attachments', { offlineAction: attachmentsCopy.en.offlineAction })
